export enum ESettingsEnumType {
  COUNTRIES = 'COUNTRIES',
  LANGUAGES = 'LANGUAGES',
  SPONSOR_TYPE = 'SPONSOR_TYPE',
  SPONSOR_STATUS = 'SPONSOR_STATUS',
  BUSINESS_UNIT_TYPE = 'BUSINESS_UNIT_TYPE',
  BUSINESS_MODEL_TYPE = 'BUSINESS_MODEL_TYPE',
  PARTNER_CATEGORY = 'PARTNER_CATEGORY',
  PRICING_MODEL = 'PRICING_MODEL',
}
